/**
 * Departamentos de Colombia (32) + Bogotá D.C. = 33 entradas.
 *
 * El contrato guarda el departamento como texto legible (`state`, columna `state` de la
 * `Location` del core) y el backend no expone un catálogo: la lista vive en el front,
 * igual que las etiquetas de estado. Son los nombres oficiales (sin la coletilla
 * "Departamento de"), ordenados alfabéticamente con Bogotá D.C. al final por ser el
 * Distrito Capital.
 */
export const COLOMBIA_DEPARTMENTS: readonly string[] = [
  'Amazonas',
  'Antioquia',
  'Arauca',
  'Atlántico',
  'Bolívar',
  'Boyacá',
  'Caldas',
  'Caquetá',
  'Casanare',
  'Cauca',
  'Cesar',
  'Chocó',
  'Córdoba',
  'Cundinamarca',
  'Guainía',
  'Guaviare',
  'Huila',
  'La Guajira',
  'Magdalena',
  'Meta',
  'Nariño',
  'Norte de Santander',
  'Putumayo',
  'Quindío',
  'Risaralda',
  'San Andrés y Providencia',
  'Santander',
  'Sucre',
  'Tolima',
  'Valle del Cauca',
  'Vaupés',
  'Vichada',
  'Bogotá D.C.',
];
